import React, { useEffect } from "react"
import { X } from "lucide-react"

type CrudFilterSheetProps = {
  open: boolean
  onClose: () => void
  activeCount: number
  onClearAll?: () => void
  children: React.ReactNode
}

export function CrudFilterSheet({
  open,
  onClose,
  activeCount,
  onClearAll,
  children,
}: CrudFilterSheetProps) {
  useEffect(() => {
    if (!open) return
    const prev = document.body.style.overflow
    document.body.style.overflow = "hidden"
    return () => {
      document.body.style.overflow = prev
    }
  }, [open])

  if (!open) return null

  return (
    <>
      <div
        className="fixed inset-0 z-40 bg-black/50 md:hidden"
        aria-hidden
        onClick={onClose}
      />
      <div
        className="fixed inset-x-0 bottom-0 z-50 flex max-h-[85dvh] flex-col rounded-t-xl border border-slate-gray/15 bg-white shadow-xl md:hidden"
        role="dialog"
        aria-modal="true"
        aria-label="Filters"
      >
        <div className="flex items-center justify-between border-b border-slate-100 px-4 py-3">
          <div>
            <h2 className="text-sm font-semibold text-deep-ocean">Filters</h2>
            {activeCount > 0 ? (
              <p className="text-xs text-slate-gray">{activeCount} active</p>
            ) : null}
          </div>
          <button
            type="button"
            onClick={onClose}
            className="flex h-9 w-9 items-center justify-center rounded-lg text-slate-gray hover:bg-slate-100"
            aria-label="Close filters"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain p-4">{children}</div>

        <div className="flex gap-2 border-t border-slate-100 p-4 pb-[max(1rem,env(safe-area-inset-bottom))]">
          {onClearAll ? (
            <button
              type="button"
              onClick={() => {
                onClearAll()
              }}
              className="h-10 flex-1 rounded-lg border border-slate-gray/20 text-sm font-medium text-slate-gray hover:bg-light-sky/50"
            >
              Clear all
            </button>
          ) : null}
          <button
            type="button"
            onClick={onClose}
            className="h-10 flex-1 rounded-lg bg-electric-blue text-sm font-medium text-white hover:bg-btn-hover"
          >
            Done
          </button>
        </div>
      </div>
    </>
  )
}
